import request from "../utils/request";
const { swSewagePath, iotUrl } = window.globalConfig;

// 字典表模板
export class dictApi {
  /**
   * 字典表按照分类查询
   */
  static selectWithClassifyKey = (params) => {
    return request.post(
      `/${swSewagePath}/api/dict/selectWithClassifyKey`,
      params
    );
  };

  /**
   * 字典表按照分类查询(污水)
   */

  static selectAllClassify = (params) => {
    return request.post(`/${swSewagePath}/api/dict/selectAllClassify`, params);
  };

  /**
   * 字典表分页
   */

  static selectByPage = (params) => {
    return request.post(`/${swSewagePath}/api/dict/selectByPage`, params);
  };

  /**
   * 新增字典分类
   */

  static insertClassify = (params) => {
    return request.post(`/${swSewagePath}/api/dict/insertClassify`, params);
  };

  /**
   * 新增字典分类
   */

  static delClassify = (params) => {
    return request.post(`/${swSewagePath}/api/dict/delClassify`, params);
  };

  /**
   * 修改字典分类
   */

  static ModifyClassify = (params) => {
    return request.post(`/${swSewagePath}/api/dict/ModifyClassify`, params);
  };

  /**
   * 新增字典
   */

  static dictCreate = (params) => {
    return request.post(`/${swSewagePath}/api/dict/create`, params, {
      headers: {
        "X-TOKE": sessionStorage.getItem("token"),
      },
    });
  };

  /**
   * 编辑字典
   */

  static dictUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/dict/update`, params, {
      headers: {
        "X-TOKE": sessionStorage.getItem("token"),
      },
    });
  };

  /**
   * 删除字典
   */

  static dictDel = (params) => {
    return request.post(`/${swSewagePath}/api/dict/deleteById`, params);
  };
}

// ai预警模块
export class forecastApi {
  /**
   * AI预警悬浮球立即处理
   */
  static promptlyHandle = (params) => {
    return request.post(`/${swSewagePath}/api/forecast/promptlyHandle`, params);
  };

  /**
   * AI预警悬浮球分页列表
   */
  static selectForecastByPage = (params) => {
    return request.post(
      `/${swSewagePath}/api/forecast/selectForecastByPage`,
      params
    );
  };

  /**
   * AI预警悬浮球详情
   */
  static selectForecastInfo = (params) => {
    return request.post(
      `/${swSewagePath}/api/forecast/selectForecastInfo`,
      params
    );
  };
}

// 厂站管理模块
export class stationgisApi {
  /**
   * 站点详情信息查询
   */
  static selectGisStationInfo = (params) => {
    return request.appid(
      `/${swSewagePath}/api/stationgis/selectGisStationInfo?stationId=${params.stationId}`
    );
  };

  /**
   * GIS站点列表查询
   */
  static selectGisStationList = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationgis/selectGisStationList`,
      params
    );
  };
}

// 工艺流程模块
export class stationflowchart {
  // 查询站点下所有摄像头
  static findCameraByStationId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/stationflowchart/findCameraByStationId?stationId=${params.id}`
    );
  };
  // 查询站点下所有摄像头----海康
  static listCamerasByRegion = (params) => {
    return request.post(
      `/${swSewagePath}/api/hikSec/listCamerasByRegion`,
      params
    );
  };
  // 查询播放url----海康
  static getPreviewURLs = (params) => {
    return request.post(`/${swSewagePath}/api/hikSec/getPreviewURLs`, params);
  };

  // 根据站点id和工艺单元id查询设备展示信息
  static findDisplayByProcessunitId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/stationflowchart/findDisplayByProcessunitId?stationId=${params.stationId}&processunitId=${params.processunitId}`
    );
  };

  /**
   * 根据站点id查询设备展示信息
   */
  static findDisplayByStationId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/stationflowchart/findDisplayByStationId?stationId=${params.stationId}`
    );
  };

  // 查询站点下所有参数设置
  static findParSetByStationId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/stationflowchart/findParSetByStationId?stationId=${params.stationId}`
    );
  };

  // 修改设备参数值
  static update = (params) => {
    return request.post(`/${swSewagePath}/api/stationflowchart/update`, params);
  };
}

// 告警模块
export class alarmApi {
  /**
   * 关闭告警
   */
  static closeAlarm = (params) => {
    return request.post(`/${swSewagePath}/api/alarm/closeAlarm`, params);
  };

  /**
   * 提交处理意见
   */
  static handleIdea = (params) => {
    return request.post(`/${swSewagePath}/api/alarm/handleIdea`, params);
  };

  /**
   * 告警分页查询
   */
  static selectAlarmByPage = (params) => {
    return request.post(`/${swSewagePath}/api/alarm/selectAlarmByPage`, params);
  };

  /**
   * 获取告警详情
   */
  static selectAlarmDetail = (params) => {
    return request.appid(
      `/${swSewagePath}/api/alarm/selectAlarmDetail?dutyUserName=${params.dutyUserName}&alarmId=${params.alarmId}`
    );
  };

  /**
   * 获取告警数量(未读告警数 & 处理中告警数 &已完成告警数 & 未读和处理中告警数)
   */
  static selectAllAlarmNum = (params) => {
    return request.post(`/${swSewagePath}/api/alarm/selectAllAlarmNum`, params);
  };
}

// 告警设置模板
export class alarmset {
  /**
   * 告警设置列表
   */
  static selectList = (params) => {
    return request.post(`/${swSewagePath}/api/alarmset/selectList`, params);
  };

  /**
   * 告警设置生效
   */
  static updateRedAlarmSetById = (params) => {
    return request.appid(
      `/${swSewagePath}/api/alarmset/updateRedAlarmSetById?alarmSetId=${params.alarmSetId}`
    );
  };

  /**
   * 告警设置修改(仅黄色告警能修改)
   */
  static updateYellowAlarmSetById = (params) => {
    return request.post(
      `/${swSewagePath}/api/alarmset/updateYellowAlarmSetById`,
      params
    );
  };
}

// 告警类型设置模块
export class alarmtypeset {
  /**
   * 告警类型设置列表
   */
  static selectList = (params) => {
    return request.post(`/${swSewagePath}/api/alarmtypeset/selectList`, params);
  };

  /**
   * 告警类型设置开关
   */
  static updateAlarmTypeSetSwitchById = (params) => {
    return request.post(
      `/${swSewagePath}/api/alarmtypeset/updateAlarmTypeSetSwitchById`,
      params
    );
  };
}

// 设备管理基础模块
export class deviceApi {
  /**
   * 新增设备
   */
  static create = (params) => {
    return request.post(`/${swSewagePath}/api/device/create`, params, {
      useMineErrMsg: true,
    });
  };

  /**
   * 编辑设备
   */
  static update = (params) => {
    return request.post(`/${swSewagePath}/api/device/update`, params, {
      useMineErrMsg: true,
    });
  };

  /**
   * 删除设备
   */
  static deleteById = (params) => {
    return request.delete(
      `/${swSewagePath}/api/device/deleteById?deviceId=${params.deviceId}`,
      params
    );
  };

  /**
   * 通过Id查询设备VO
   */
  static getById = (params) => {
    return request.appid(
      `/${swSewagePath}/api/device/getById?deviceId=${params.deviceId}`
    );
  };

  /**
   * 查询告警列表
   */
  static selectAlarmsByDevId = (params) => {
    return request.post(
      `/${swSewagePath}/api/device/selectAlarmsByDevId`,
      params
    );
  };

  /**
   * 设备批量导入数据校验
   */
  static dlBaImDeTempDataCheck = (params, config) => {
    return request.post(
      `/${swSewagePath}/api/device/dlBaImDeTempDataCheck`,
      params,
      config
    );
  };

  /**
   * 设备批量导入
   */
  static dlBaImDeTempDataUpload = (params, config) => {
    return request.post(
      `/${swSewagePath}/api/device/dlBaImDeTempDataUpload`,
      params,
      config
    );
  };

  /**
   * 根据站点查询物料、工艺单元、采集设备
   */
  static selectByStationId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/device/selectByStationId?stationId=${params.stationId}`
    );
  };

  /**
   * 已入库设备
   */
  static selectStorageByStationId = (params) => {
    return request.appid(
      `/${swSewagePath}/api/device/selectStorageByStationId?stationId=${params.stationId}`
    );
  };

  /**
   * 设备分页查询
   */
  static selectDeviceByPage = (params) => {
    return request.post(
      `/${swSewagePath}/api/device/selectDeviceByPage`,
      params
    );
  };

  /**
   * 站点的设备批量导入模板下载
   */
  static downloadBaImDeTemp = (params, config) => {
    return request.appid(
      `/${swSewagePath}/api/device/downloadBaImDeTemp`,
      config
    );
  };
}

// 站点模块
export class stationApi {
  /**
   * 查询当前登陆人责任得站点名称
   */
  static selectStationNameList = (params) => {
    return request.post(
      `/${swSewagePath}/api/station/selectStationNameList`,
      params
    );
  };

  /**
   * 新增/修改站点工艺拖拽配置JSON
   */
  static stationProcessSet = (params) => {
    return request.post(
      `/${swSewagePath}/api/station/stationProcessSet`,
      params
    );
  };

  /**
   * 获取站点下所有工艺点
   *
   */
  static findProcessByStationId = (id) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findProcessByStationId?stationId=${id}`
    );
  };

  /**
   * 添加工艺点的属性
   *
   */
  static addProcessUnitAttr = (params) => {
    return request.post(
      `/${swSewagePath}/api/spFlow/addProcessUnitAttr`,
      params
    );
  };

  /**
   * 删除工艺点的属性
   *
   */
  static deleteUnitAttrById = (id) => {
    return request.delete(
      `/${swSewagePath}/api/spFlow/deleteUnitAttrById?id=${id}`
    );
  };

  /**
   * 修改工艺点的属性
   *
   */
  static updateProcessUnitAttr = (params) => {
    return request.post(
      `/${swSewagePath}/api/spFlow/updateProcessUnitAttr`,
      params
    );
  };

  /**
   * 修改工艺流程
   *
   */
  static updateProcessFlow = (params) => {
    return request.post(
      `/${swSewagePath}/api/spFlow/updateProcessFlow`,
      params
    );
  };

  /**
   * 获取工艺流程
   *
   *
   */
  static findFlowByStationId = (id) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findFlowByStationId?stationId=${id}`
    );
  };

  /**
   * 修改工艺单元的工艺流程
   *
   */
  static updateProcessUnitFlow = (params) => {
    return request.post(
      `/${swSewagePath}/api/spFlow/updateProcessUnitFlow`,
      params
    );
  };

  /**
   * 获取工艺单元的工艺流程
   *
   *
   */
  static findUnitFlow = (stationId, unitId) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findUnitFlow?stationId=${stationId}&unitId=${unitId}`
    );
  };

  /**
   * 根据工艺单元id获取所有属性
   *
   *
   */
  static findUnitDisplayDetail = (stationId, unitId) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findUnitDisplayDetail?stationId=${stationId}&unitId=${unitId}`
    );
  };

  /**
   * 获取已经设置了工艺单元的工艺流程
   *
   *
   */
  static selectHaveFlowUnitList = (stationId) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/selectHaveFlowUnitList?stationId=${stationId}`
    );
  };

  /**
   * 修改设备流程图
   *
   */
  static updateDeviceFlow = (params) => {
    return request.post(`/${swSewagePath}/api/spFlow/updateDeviceFlow`, params);
  };

  /**
   * 查询设备流程图
   *
   *
   */
  static findDeviceFlow = (stationId) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findDeviceFlow?stationId=${stationId}`
    );
  };

  /**
   * 设备告警设置-查询
   *
   *
   */
  static findDeviceAlarmSetByAttrId = (id) => {
    return request.appid(
      `/${swSewagePath}/api/spFlow/findDeviceAlarmSetByAttrId?diyAttrId=${id}`
    );
  };

  /**
   * 设备告警设置-修改设置
   *
   */
  static updateDeviceAlarmSet = (params) => {
    return request.post(
      `/${swSewagePath}/api/spFlow/updateDeviceAlarmSet`,
      params
    );
  };

  /**
   * 发送指令
   *
   */
  static devicePut = (params) => {
    return request.post(`/${iotUrl}/sys/0/command/devicePut`, params);
  };

  /**
   * 碳源投加
   *
   */
  static carbonSource = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/selectData`,
      params
    );
  };

  // 碳源数据设置
  static carbonSourceSetParams = (params) => {
    return request.post(`/${swSewagePath}/api/carbonSource/setParams`, params);
  };

  // 获取碳源投加分析
  static getCarbonIntellectAnalyzeChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getCarbonIntellectAnalyzeChart`,
      params
    );
  };

  // 获取除磷分析
  static getPhosphorusIntellectAnalyzeChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getPhosphorusIntellectAnalyzeChart`,
      params
    );
  };

  // 获取回流分析
  static getReflowIntellectAnalyzeChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getReflowIntellectAnalyzeChart`,
      params
    );
  };

  // 智能曝气左侧图表
  static getPhosphorusAnalyzeLeftChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getPhosphorusAnalyzeLeftChart`,
      params
    );
  };

  // 智能曝气右侧图表
  static getPhosphorusAnalyzeRightChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getPhosphorusAnalyzeRightChart`,
      params
    );
  };

  // 智能回流左侧图表
  static getReflowAnalyzeLeftChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getReflowAnalyzeLeftChart`,
      params
    );
  };

  // 智能回流右侧图表
  static getReflowAnalyzeRightChart = (params) => {
    return request.appid(
      `/${swSewagePath}/api/carbonSource/getReflowAnalyzeRightChart`,
      params
    );
  };
}
